var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandcamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 65C50.4492 65 65 50.4492 65 32.5C65 14.5508 50.4492 0 32.5 0C14.5508 0 0 14.5508 0 32.5C0 50.4492 14.5508 65 32.5 65ZM27.2869 41.3408H5.72791L14.1139 23.1611H35.6731L27.2869 41.3408ZM35.6731 23.1611L37.8307 23.1606V29.5737H37.8802C38.812 28.2227 40.0867 27.6084 41.583 27.5835C44.9915 27.5835 46.9282 30.3853 46.9285 33.9971C46.9285 37.0674 45.6534 41.1704 41.2883 41.1704C39.1063 41.1704 38.199 39.918 37.7576 39.2056H37.7089V40.8027H35.6729L35.6731 23.1611ZM41.2393 39.3042C39.8667 39.3042 37.7332 38.3945 37.7332 34.9795C37.7332 32.8906 38.0758 29.5249 41.1904 29.5249C44.5253 29.5249 44.6969 32.6948 44.6969 34.3408C44.6969 37.1655 43.5934 39.3042 41.2393 39.3042ZM57.1881 32.2764C56.9188 30.5566 55.9614 29.5249 54.1469 29.5249C51.4752 29.5249 50.6169 32.0796 50.6167 34.3652C50.6167 36.5767 51.1567 39.3042 54.1237 39.3042C55.5699 39.3042 56.8198 38.2227 57.1881 36.2568H59.272C59.0521 38.2959 57.8009 41.1704 54.0493 41.1704C50.4451 41.1704 48.3119 38.4443 48.3119 34.7329C48.3119 30.7534 50.2239 27.5835 54.4658 27.5835C57.8254 27.5835 59.1005 30.041 59.272 32.2764H57.1881Z",
    fill: "#65929A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandcamp);
export default __webpack_public_path__ + "static/media/bandcamp.31ad012a6cf69d21d3d863e934a1ae84.svg";
export { ForwardRef as ReactComponent };